import AmexLoading from './AmexLoading';

export default AmexLoading;
